import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-d950eba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticker" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segments, (seg) => {
      return (_openBlock(), _createElementBlock("span", {
        key: seg.k,
        class: "ticker-seg"
      }, _toDisplayString(seg.text), 1))
    }), 128))
  ]))
}